import React, { createContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useSelector } from "react-redux";
import { errorMsg } from "../utils/toastMessage";

const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
const connectionUrl = `${baseUrl}socket`;
// const connectionUrl = "http://localhost:4000/socket";

export const Context = createContext();

export default function ContextProvider({ children }) {
  const { loggedinUser } = useSelector((state) => state.auth);

  const [socket, setSocket] = useState("");
  const [failedCount, setFailedCount] = useState(0);

  const handleSocketConnection = async () => {
    try {
      const mySocket = io(connectionUrl, {
        // const mySocket = io("http://localhost:4000", {
        // autoConnect: false,
        transports: ["websocket", "polling", "flashsocket"],
        auth: {
          token: loggedinUser.token,
          userId: loggedinUser.userId,
        },
      });

      // mySocket.auth = { token: "test" };
      // socket.connect();

      if (mySocket) {
        setSocket(mySocket);

        mySocket.emit("client", { userId: loggedinUser.userId }, (response) => {
          console.log("client socket connected", response);
        });

        mySocket.on("connect_error", (err) => {
          console.error("Socket connection error:", err);
          setFailedCount((prev) => prev + 1);
          errorMsg(`Connection Error: ${err.message}`);
          setSocket(null);
          mySocket.disconnect();
        });

        mySocket?.on("error", (err) => {
          setFailedCount((prev) => prev + 1);
          console.error("General socket Error:", err);
          setSocket(null);
        });
      }
    } catch (error) {
      setFailedCount((prev) => prev + 1);
      console.log("socket connection error", error);
    }
  };

  useEffect(() => {
    if (loggedinUser?.userId && !socket && failedCount <= 2) {
      handleSocketConnection();
    }
  }, [loggedinUser, socket]);

  return <Context.Provider value={{ socket }}>{children}</Context.Provider>;
}
